import { stringLength, createValidator, stringTrim } from 'app/validators/base'

const validate = stringLength({ min: 1, max: 400 }, stringTrim)

export default createValidator(validate, 'story')
